import { PerformanceTimelineInstrumentation } from '@grafana/faro-instrumentation-performance-timeline';
import { XHRInstrumentation } from '@grafana/faro-instrumentation-xhr';
import {
  createReactRouterV6Options,
  getWebInstrumentations,
  initializeFaro,
  ReactIntegration,
} from '@grafana/faro-react';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { FlagProvider } from '@unleash/proxy-client-react';
import { Amplify } from 'aws-amplify';
import ReactDOM from 'react-dom';
import {
  createRoutesFromChildren,
  matchRoutes,
  Routes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

import { getExports } from 'services';
import { getAwsExports } from 'services/amplify';

import App from './App';
import { initDatadog } from './libraries/datadog';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
    },
  },
});

getAwsExports().then(awsExports => {
  Amplify.configure(awsExports);

  initDatadog();

  getExports().then(config => {
    const unleashInitialConfig = {
      url: config?.unleashApiUrl,
      clientKey: config?.unleashApiKey,
      refreshInterval: config?.unleashApiRefreshInterval || 60,
      appName: 'Wellz',
      environment: 'production',
    };

    initializeFaro({
      url: config?.grafanaFaroUrl,
      app: {
        name: config?.appName,
      },
      trackWebVitalsAttribution: true,
      instrumentations: [
        ...getWebInstrumentations({
          captureConsole: true,
        }),
        new ReactIntegration({
          router: createReactRouterV6Options({
            createRoutesFromChildren,
            matchRoutes,
            Routes,
            useLocation,
            useNavigationType,
          }),
        }),
        new TracingInstrumentation(),
        new XHRInstrumentation(),
        new PerformanceTimelineInstrumentation(),
      ],
    });

    ReactDOM.render(
      <QueryClientProvider client={queryClient}>
        <FlagProvider config={unleashInitialConfig}>
          <App />
        </FlagProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>,
      document.getElementById('root'),
    );
  });
});
